import { throttle } from './common'

let scroll, last

// detection du scroll de la page (throttled)
function scrolled() {
  scroll = window.pageYOffset || document.documentElement.scrollTop
  last = last || 0
  document.body.classList.toggle('scrolled', scroll > 1)
  last = scroll < 0 ? 0 : scroll
}

window.addEventListener('scroll', throttle(scrolled, 50))

scrolled()
